import React from 'react';
import { Box } from '@mui/material';

import AdviceFooter from './AdviceFooter';

const disclosureLinkStyle = {
    color: '#FFFFFF',
    textDecoration: 'underline'
}

const disclosuresOverrideStyles = { backgroundColor: '#00345C', paddingTop: '48px', paddingBottom: '48px', color: '#FFFFFF' }

const lrnNumber = '202505-4385944';

const FooterDisc = () => (
    <div id="footer-disclosure-content" className="b-typography-sans-serif--caption--300 b-font-weight-light">
        <p>
            All investments involve risk, including possible loss of principal.
        </p>
        <p style={{paddingTop: "12px"}} className="b-typography-sans-serif--caption--300 b-font-weight-light"> 
            Advisory services are offered by <span style={{whiteSpace: "nowrap"}}>T. Rowe Price</span> Advisory Services, Inc., a registered investment
            adviser under the Investment Advisers Act of 1940. <span style={{whiteSpace: "nowrap"}}>T. Rowe Price</span> Advisory Services
            and <span style={{whiteSpace: "nowrap"}}>T. Rowe Price</span> Investment
            Services are affiliated companies.
        </p>
    </div>
)

const RicFooterDisc = () => (
    <Box id="ric-footer-disclosure-content" className='beacon-theme-modern-outlook' sx={{ inlineSize: 'unset' }}>
        <p id="disclosure-1" className="b-typography-sans-serif--caption--300 b-font-weight-light">
            Please see information about our&nbsp;
            <a
                style={disclosureLinkStyle}
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.troweprice.com/content/dam/iinvestor/Forms/retirement-income-calculator-methodology.pdf"
            >
                Methodology and Assumptions.
            </a>
        </p>
        <p id="disclosure-2" className="b-typography-sans-serif--caption--300 b-font-weight-light">
            *Hypothetical investment allocations: Conservative (30% equity, 70%
            bonds), Moderate (60% equity, 40% bonds), or Aggressive (90% equity,
            10% bonds). Allocations are assumed to remain constant.
            For details on this and other assumptions, please read
            our&nbsp;
            <a
                style={disclosureLinkStyle}
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.troweprice.com/content/dam/iinvestor/Forms/retirement-income-calculator-methodology.pdf"
            >
                Methodology and Assumptions.
            </a>
        </p>
        <p id="disclosure-3" className="b-typography-sans-serif--caption--300 b-font-weight-light">
            The information provided in this tool is for general and educational
            purposes only, and is not intended to provide legal, tax or investment
            advice. This tool allows you to explore hypothetical future scenarios
            to test your savings strategy. The assumptions and methodology are not
            tailored to the needs of any specific investor. Results are intended as
            an aid, are not guaranteed, and should not be your only source of
            information when making financial decisions. Please consult your tax or
            financial professional regarding questions specific to your situation.
            Other <span style={{whiteSpace: "nowrap"}}>T. Rowe Price</span> educational tools or advice services use different
            assumptions and methods and may yield different results.
        </p>
        <p id="disclosure-4" className="b-typography-sans-serif--caption--300 b-font-weight-bold">
            <b>
                IMPORTANT: The projections or other information generated by the
                Retirement Income Calculator regarding the likelihood of various investment
                outcomes are hypothetical in nature, do not reflect actual investment
                results and are not guarantees of future results.
            </b>
        </p>
        <p id="disclosure-5" className="b-typography-sans-serif--caption--300 b-font-weight-light">
            All investments involve risk, including possible
            loss of principal.
        </p>
        <p id="lrn-number" className="b-typography-sans-serif--caption--300 b-font-weight-light">
            {lrnNumber}
        </p>
    </Box>
)

const AdviceFooterImpl = ({ noPt }) => {
    const showRicDisc = !window.location.pathname.includes('invalid');
    
    return (
        <Box pt={noPt ? 'inherit' : '64px'}>
            <AdviceFooter 
                disclosures={showRicDisc ? <RicFooterDisc /> : <FooterDisc />} 
                copyright='RAS'
                disclosuresOverrideStyles={disclosuresOverrideStyles} 
            />
        </Box>
    )
}

export default AdviceFooterImpl;